// i18n/config.ts
/**
 * 1. 支持的语言列表
 * - 这里的值必须与你的文件夹名 `[lang]`、语言包文件名 `messages/{locale}.json` 完全一致
 * - 例如：如果这里写 `'zh-CN'`，那么你必须有一个 `messages/zh-CN.json` 文件
 */
export const locales = ["en", "zh", "ja"] as const;
// 如果你需要更精确的地区代码，也可以写成：
// export const locales = ['en', 'zh-CN', 'zh-TW'] as const;

/**
 * 2. 默认语言（当用户访问根路径 `/` 时，将自动重定向到此语言）
 * - 必须是上面 `locales` 数组中的某一个值
 */
export const defaultLocale: "zh" = "zh"; // 或 'en'，根据你的需求

/**
 * 3. 语言前缀显示策略 (可选但推荐)
 * - 'always': 始终显示前缀 (如 /en/about, /zh/about)
 * - 'as-needed': 默认语言不显示前缀 (如 /about 表示默认语言，/en/about 表示英文)
 */
export const localePrefix: "always" | "as-needed" = "always";

/**
 * 4. 导出语言类型（用于TypeScript类型提示，非常实用）
 * - 当你需要为函数参数或变量标注语言类型时，可以使用这个类型
 * - 例如：function getContent(locale: Locale) { ... }
 */
export type Locale = (typeof locales)[number]; // 等同于 'en' | 'zh' | 'ja'

/**
 * 5. Next-intl 配置对象
 */
export default {
  locales,
  defaultLocale,
  localePrefix,
};
